import Gift01 from "../../../../assets/Gift01";
import Hearts from "../../../../assets/Hearts";
import Percent02 from "../../../../assets/Percent02";
import MinusCircle from "../../../../assets/MinusCircle";
import CreditCard02 from "../../../../assets/CreditCard02";
import CurrencyRupeeCircle from "../../../../assets/CurrencyRupeeCircle";
import {
  getItemsArrForStore,
  convertToSingleObjects,
  findExistingRewardItem,
} from "../../../../../utils/constants/constants";

export const brandingInspirationList = [
  {
    title: "{{brand_name}} Premium Pack",
    description:
      "Enjoy exclusive discounts, sneak peeks, and personalized perks with our Premium Pack!",
  },
  {
    title: "{{brand_name}} Privilege Pass",
    description:
      "Get VIP treatment with exclusive offers, savings, and personalized perks.",
  },
  {
    title: "{{brand_name}} VIP Vault",
    description:
      "Unlock exclusive perks and special offers just for our most loyal customers!",
  },
  {
    title: "The {{brand_name}} Inner Circle",
    description:
      "Get closer to the brand you love with access to member-only benefits and deals.",
  },
  {
    title: "The {{brand_name}} Insiders' Choice",
    description:
      "Get closer to the brand you love with access to member-only benefits and deals.",
  },
];

export const benefitsOptionList = [
  {
    value: "discount_off",
    label: "Percentage discount",
  },
  {
    value: "amount_off",
    label: "Cash discount",
  },
  {
    value: "free_item_service",
    label: "Free item",
  },
  {
    value: "no_discount",
    label: "No discount",
  },
];

export const getBenefitIcon = (reward_type, color) => {
  switch (reward_type) {
    case "discount_off":
      return <Percent02 width={24} height={24} color={color} />;
    case "amount_off":
      return <CurrencyRupeeCircle size={24} color={color} />;
    case "free_item_service":
      return <Gift01 size={24} color={color} />;
    case "no_discount":
      return <MinusCircle size={24} color={color} />;
    default:
      return <Percent02 width={24} height={24} color={color} />;
  }
};

export const newEmptyRewardTemplate = {
  rewardItems: "",
  rewardPosItems: [],
  settings: {},
  is_active: true,
  description: "",
  is_combo: false,
  discount_off: "",
  applies_on: "all",
  reward_name: "",
  redemption: {
    frequency: {},
    mode: "single",
  },
};

export const getStoresArrForItems = (reward, allStoresArr) => {
  const combinedStoreItems = convertToSingleObjects(reward.items || []);
  const storesArr = allStoresArr?.reduce((prev, store) => {
    if (!store?.is_active || store?.is_draft) return prev;

    const storeWiseItems =
      findExistingRewardItem(combinedStoreItems, store) || {};

    return [
      ...prev,
      {
        store_name: store?.name,
        posName: store?.pos_keys?.name,
        store_id: store?._id || store?.id,
        isPosIntegrated: store?.pos_keys?.integration,
        combo: storeWiseItems?.combo || false,
        items_array: !store?.pos_keys?.integration
          ? storeWiseItems?.name?.length > 0
            ? storeWiseItems?.name?.split("~").join(",") || ""
            : ""
          : "",
        pos_array: store?.pos_keys?.integration
          ? getItemsArrForStore(storeWiseItems)
          : [],
      },
    ];
  }, []);
  return storesArr;
};

export const initialRewards = [
  {
    rewardItems: "",
    rewardPosItems: [],
    is_active: true,
    description: "",
    is_combo: false,
    discount_off: 20,
    applies_on: "all",
    reward_type: {
      value: "discount_off",
      label: "Percentage Discount",
    },
    reward_name: "20% off on entire purchase",
    settings: {},
    redemption: {
      frequency: {},
      mode: "single",
    },
  },
  {
    rewardItems: "",
    rewardPosItems: [],
    is_active: true,
    description: "",
    is_combo: false,
    applies_on: "all",
    reward_type: {
      value: "free_item_service",
      label: "Free item",
    },
    reward_name: "Get one free coffee every month",
    settings: {},
    redemption: {
      mode: "multiple",
      frequency: {
        times: 1,
        period: "months",
      },
    },
  },
  {
    rewardItems: "",
    rewardPosItems: [],
    is_active: true,
    description: "",
    is_combo: false,
    amount_off: 500,
    discount_off: "",
    applies_on: "all",
    reward_type: {
      value: "amount_off",
      label: "Cash Discount",
    },
    reward_name: "500₹ off on entire purchase",
    settings: {},
    redemption: {
      frequency: {},
      mode: "single",
    },
  },
  {
    rewardItems: "",
    rewardPosItems: [],
    is_active: true,
    description: "",
    is_combo: false,
    discount_off: "",
    applies_on: "all",
    reward_type: {
      value: "no_discount",
      label: "No Discount",
    },
    reward_name: "Exclusive access to members only events",
    settings: {},
    redemption: {
      mode: "single",
      frequency: {},
    },
  },
];

export const initCreativeState = {
  step: "",
  visitedSteps: [],
  text_color: "#000000",
  theme_color: "#FFCA05",

  logoKey: "",
  logoFileName: "",
  activeRewardIndex: 0,
  inspirationTemplate: 1,

  expiry: {
    duration: 12,
    period: "months",
  },
  reminder: {
    active: true,
    duration: 14,
    period: "days",
  },
  activation_settings: {
    duration: 3,
    period: "hours",
    is_active: false,
  },

  contact_info: "",
  restrict_points_to_earn: false,
  terms: [
    "2 offers cannot be clubbed",
    "Reward redeemable in-store only",
    "Merchant reserves the right to final say",
  ].map((term) => ({
    value: term,
    isSelected: true,
    key: `${term}_${Math.random()}`,
  })),
  title: brandingInspirationList[0].title,
  description: brandingInspirationList[0].description,
};

export const promotionObjectives = [
  {
    title: "Empower your team",
    subtitle:
      "Get your team excited about memberships. Enable them to promote and track sign-ups effectively.",
    bgColor: "#F0FDF9",
    imgSrc: "/assets/images/membership/promotions/objective_1.svg",
    url: "/membership/promotions/team-member",
    key: "team_member",
  },
  {
    title: "Place in-store Creatives",
    subtitle: "Showcase your membership benefits where customers can see them.",
    bgColor: "#F4F3FF",
    imgSrc: "/assets/images/membership/promotions/objective_2.svg",
    url: "/membership/promotions/in-store",
    key: "in_store",
  },
  {
    title: "Engage with campaigns",
    subtitle:
      "Keep your customers informed about your exclusive membership program.",
    bgColor: "#FFF6F8",
    imgSrc: "/assets/images/membership/promotions/objective_3.svg",
    url: "/membership/promotions/campaign",
    key: "campaign",
  },
];

export const viewPayoutLink =
  "https://accounts.razorpay.com/auth/?auth_intent=login&redirecturl=https%3A%2F%2Fdashboard.razorpay.com%2Fapp%2Ftransfers&x-country-code=IN";

export const promotionObjectivesModalData = {
  team_member: {
    name: "Empower your team",
    title: "Use team QR codes to boost membership sales",
    subtitle:
      "QR codes for each team member to track their membership conversions and build healthy competition.",
    features: [
      {
        image: "/assets/images/membership/promotions/modal/team_member_1.webp",
        title: "Track individual team performance",
      },
      {
        image: "/assets/images/membership/promotions/modal/team_member_2.webp",
        title: "Monitor real-time conversion rates",
      },
      {
        image: "/assets/images/membership/promotions/modal/team_member_3.webp",
        title: "Reward top performers",
      },
    ],
    btnUrl: "/membership/promotions/team-member",
  },
  in_store: {
    name: "In Store Creatives",
    title: "Transform Your Space Into a Membership Hub",
    subtitle:
      "From table standees to wall posters, turn your physical space into a membership conversion engine.",
    features: [
      {
        image: "/assets/images/membership/promotions/modal/in_store_1.webp",
        title: "Catch attention at the right moment",
      },
      {
        image: "/assets/images/membership/promotions/modal/in_store_2.webp",
        title: "Make sign-ups effortless with QR codes",
      },
      {
        image: "/assets/images/membership/promotions/modal/in_store_3.webp",
        title: "Measure offline promotion success",
      },
    ],
    btnUrl: "/membership/promotions/in-store",
  },
  campaign: {
    name: "Engage with Campaigns",
    title: "Power Up Your Memberships With Campaigns",
    subtitle:
      "Turn your audience engagement into membership sign-ups with strategic digital campaigns.",
    features: [
      {
        image: "/assets/images/membership/promotions/modal/campaign_1.webp",
        title: "Promote your memberships via online channels",
      },
      {
        image: "/assets/images/membership/promotions/modal/campaign_2.webp",
        title: "Customers purchase through the received communications",
      },
      {
        image: "/assets/images/membership/promotions/modal/campaign_3.webp",
        title: "Track the perfromance and ROI of each campaigns",
      },
    ],
    btnUrl: "/membership/promotions/campaign",
  },
};

export const restrictPointsTerm =
  "Loyalty points will not be earned on orders with membership reward redemption";
export const activationSettingTerm =
  "Membership will be activated 3 hours after the purchase";

export const multipleRedemptionCondition =
  "Reward redeemable once every {{period}} till membership expiry.";
export const minPurchaseCondition =
  "Minimum purchase of {{min_bill_amount}} required.";

export const shortlinkFAQs = [
  {
    question: "How do I redeem the benefits of this membership?",
    answer:
      "Once you purchase the membership, you can redeem the benefits directly at participating outlets. Simply provide your registered phone number at the time of billing, and the applicable discounts or rewards will be applied automatically.",
  },
  {
    question: "What happens if I don’t use my membership before it expires?",
    answer:
      "Unused benefits do not carry over after the membership expires. We recommend making the most of your membership within the validity period to enjoy all the perks.",
  },
  {
    question:
      "What payment methods are accepted for purchasing the membership?",
    answer:
      "You can purchase the membership using online payment methods, including credit/debit cards, UPI, net banking, and digital wallets, depending on the available payment options at checkout.",
  },
  {
    question: "Can I cancel my membership after purchase?",
    answer:
      "Membership purchases are typically non-cancellable and non-refundable. However, if you face any issues, please contact our support team for assistance.",
  },
  {
    question: "Is there a refund policy if I don’t use my membership?",
    answer:
      "No, we do not offer refunds for unused memberships. The membership provides access to exclusive benefits, so we encourage you to utilize them during the validity period.",
  },
  {
    question:
      "Can I transfer my membership to a different phone number or account?",
    answer:
      "Memberships are non-transferable and linked to your registered phone number or account. If you need any changes, please reach out to our support team for guidance.",
  },
];

export const sampleMemberships = [
  {
    expires_at: "2025-04-13T18:29:59.999Z",
    membership: {
      status: "active",
      _id: "67e1b6873e2756157487dd77",
      entity_id: "123456789",
      entity_type: "Group",
      type: "reward_bundle",
      terms: [
        "2 offers cannot be clubbed",
        "Reward redeemable in-store only",
        "Merchant reserves the right to final say",
      ].map((term) => ({
        value: term,
        isSelected: true,
        key: `${term}_${Math.random()}`,
      })),
      landing_page_settings: {
        title: "Membership Landing Page",
        description: "Membership Landing Page Description",
        logo: "https://reelo-uploads-dev.s3.ap-south-1.amazonaws.com/uploads/users/6582ac038f9449faf58c5392/1724762865976.png",
        colors: {
          text: "#ffffff",
          theme: "#007bff",
        },
        contact_info: "9999999999",
      },
      subscription_details: {
        price: 1000,
        customer_saves_on_purchase: 400,
      },
      settings: {
        membership_expiry: {
          duration: 12,
          period: "months",
        },
      },
      applicable_stores: [
        {
          id: "123456789",
          name: "Store 1",
        },
        {
          id: "123456782",
          name: "Store 2",
        },
      ],
    },
    rewards: [
      {
        _id: "1",
        combo: false,
        is_active: true,
        reward_type: "amount_off",
        name: "Get 20% off on every purchase",
        description: "",
        applies_on: "single",
        amount_off: 100,
        discount_off: 0,
        settings: {
          max_discount: {
            is_active: false,
            value: 0,
          },
          min_bill_for_redemption: {
            active: false,
            amount: 0,
          },
        },
        items: [
          {
            id: "abcd",
            name: "Membership Bundle",
          },
        ],
        redeemed_count: 6,
        total_redemptions_allowed: 12,
        redemption: {
          mode: "multiple",
          frequency: "weeks",
        },
      },
      {
        _id: "2",
        combo: false,
        is_active: true,
        reward_type: "discount_off",
        name: "Get 20% off on every purchase",
        description: "",
        applies_on: "all",
        amount_off: 0,
        discount_off: 20,
        settings: {
          max_discount: {
            is_active: false,
            value: 0,
          },
          min_bill_for_redemption: {
            active: false,
            amount: 0,
          },
        },
        items: [],
        redeemed_count: 0,
        total_redemptions_allowed: 12,
        redemption: {
          mode: "multiple",
          frequency: "weeks",
        },
      },
      {
        _id: "3",
        combo: false,
        is_active: true,
        reward_type: "free_item_service",
        name: "Get free items on every purchase",
        description: "",
        applies_on: "all",
        amount_off: 0,
        discount_off: 0,
        settings: {
          max_discount: {
            is_active: false,
            value: 0,
          },
          min_bill_for_redemption: {
            active: false,
            amount: 0,
          },
        },
        items: [
          {
            id: "abcd",
            name: "Membership Bundle",
          },
        ],
        redeemed_count: 1,
        total_redemptions_allowed: 1,
        redemption: {
          mode: "single",
        },
      },
      {
        _id: "4",
        combo: false,
        is_active: true,
        reward_type: "no_discount",
        name: "No discount title",
        description: "No discount description",
        applies_on: "all",
        amount_off: 0,
        discount_off: 0,
        settings: {
          max_discount: {
            is_active: false,
            value: 0,
          },
          min_bill_for_redemption: {
            active: false,
            amount: 0,
          },
        },
        items: [],
      },
    ],
  },
  {
    expires_at: "2025-04-06T18:29:59.999Z",
    membership: {
      status: "active",
      _id: "67e1b7d03e2756157487dd7f",
      entity_id: "123456789",
      entity_type: "Group",
      type: "reward_bundle",
      terms: [
        "2 offers cannot be clubbed",
        "Reward redeemable in-store only",
        "Merchant reserves the right to final say",
      ].map((term) => ({
        value: term,
        isSelected: true,
        key: `${term}_${Math.random()}`,
      })),
      created_at: "2025-04-01T08:27:02.253+00:00",
      updated_at: "2025-04-01T08:27:02.253+00:00",
      landing_page_settings: {
        title: "Membership Landing Page 2",
        description: "Membership Landing Page Description 2",
        logo: "https://reelo-uploads-dev.s3.ap-south-1.amazonaws.com/uploads/users/6582ac038f9449faf58c5392/1724762865976.png",
        colors: {
          text: "#ffffff",
          theme: "#007bff",
        },
        contact_info: "9999999999",
      },
      subscription_details: {
        price: 1000,
        customer_saves_on_purchase: 400,
      },
      settings: {
        membership_expiry: {
          duration: 12,
          period: "months",
        },
      },
      applicable_stores: [
        {
          id: "123456789",
          name: "Store 1",
        },
        // {
        //   id: "123456782",
        //   name: "Store 2",
        // },
      ],
    },
    rewards: [
      {
        _id: "1",
        combo: false,
        is_active: true,
        reward_type: "amount_off",
        name: "Get 20% off on every purchase",
        description: "",
        applies_on: "single",
        amount_off: 100,
        discount_off: 0,
        settings: {
          max_discount: {
            is_active: false,
            value: 0,
          },
          min_bill_for_redemption: {
            active: false,
            amount: 0,
          },
        },
        items: [
          {
            id: "abcd",
            name: "Membership Bundle",
          },
        ],
        redeemed_count: 6,
        total_redemptions_allowed: 12,
        redemption: {
          mode: "multiple",
          frequency: "weeks",
        },
      },
      {
        _id: "2",
        combo: false,
        is_active: true,
        reward_type: "discount_off",
        name: "Get 20% off on every purchase",
        description: "",
        applies_on: "all",
        amount_off: 0,
        discount_off: 20,
        settings: {
          max_discount: {
            is_active: false,
            value: 0,
          },
          min_bill_for_redemption: {
            active: false,
            amount: 0,
          },
        },
        items: [],
        redeemed_count: 0,
        total_redemptions_allowed: 12,
        redemption: {
          mode: "multiple",
          frequency: "weeks",
        },
      },
      {
        _id: "3",
        combo: false,
        is_active: true,
        reward_type: "free_item_service",
        name: "Get free items on every purchase",
        description: "",
        applies_on: "all",
        amount_off: 0,
        discount_off: 0,
        settings: {
          max_discount: {
            is_active: false,
            value: 0,
          },
          min_bill_for_redemption: {
            active: false,
            amount: 0,
          },
        },
        items: [
          {
            id: "abcd",
            name: "Membership Bundle",
          },
        ],
        redeemed_count: 1,
        total_redemptions_allowed: 1,
        redemption: {
          mode: "single",
        },
      },
      {
        _id: "4",
        combo: false,
        is_active: true,
        reward_type: "no_discount",
        name: "No discount title",
        description: "No discount description",
        applies_on: "all",
        amount_off: 0,
        discount_off: 0,
        settings: {
          max_discount: {
            is_active: false,
            value: 0,
          },
          min_bill_for_redemption: {
            active: false,
            amount: 0,
          },
        },
        items: [],
      },
    ],
  },
];

export const sampleActivityData = {
  docs: [
    {
      bill_amount: 1000,
      membership_type: "reward_bundle",
      action: "membership:purchase",
      _id: "62e4d0b8c9b0d1e0c0e1f2f3",
      date_time: "Tue, Oct 3, 2023, 9:50 am",
    },
  ],
  totalDocs: 1,
  limit: 10,
  page: 1,
  totalPages: 1,
  pagingCounter: 1,
  hasPrevPage: false,
  hasNextPage: false,
  prevPage: null,
  nextPage: null,
};

export const promotionObjectiveSideModalData = {
  team_member: [
    {
      title: "Generate Unique QR Codes for team",
      subtitle: "STEP 1",
      contentImg:
        "/assets/images/membership/promotions/modal/team_member_help_1.webp",
    },
    {
      title:
        "Distribute QRs among team members and educate them to pitch it to your loyal customers.",
      subtitle: "STEP 2",
      contentImg:
        "/assets/images/membership/promotions/modal/team_member_help_2.webp",
    },
    {
      title: "Track membership sales conversions for each QR",
      subtitle: "STEP 3",
      contentImg:
        "/assets/images/membership/promotions/modal/team_member_help_3.webp",
    },
    {
      title: "Drive Healthy Competition by displaying top performers",
      subtitle: "STEP 4",
      contentImg:
        "/assets/images/membership/promotions/modal/team_member_help_4.webp",
    },
  ],
  in_store: [
    {
      title: "Design & Download Creatives",
      subtitle: "STEP 1",
      contentImg:
        "/assets/images/membership/promotions/modal/in_store_help_1.webp",
    },
    {
      title: "Place Creatives in your Store",
      subtitle: "STEP 2",
      contentImg:
        "/assets/images/membership/promotions/modal/in_store_help_2.webp",
    },
    {
      title: "Track Signups & Performance",
      subtitle: "STEP 3",
      contentImg:
        "/assets/images/membership/promotions/modal/in_store_help_3.webp",
    },
  ],
  campaign: [
    {
      title:
        "Reelo automatically identifies customers who are likely to buy your memberships",
      subtitle: "STEP 1",
      contentImg:
        "/assets/images/membership/promotions/modal/campaign_help_1.svg",
    },
    {
      title: `Send a "Membership Launch" campaign to reelo recommneded customers`,
      subtitle: "STEP 2",
      contentImg:
        "/assets/images/membership/promotions/modal/campaign_help_2.svg",
    },
    {
      title:
        "Track how many memberships are being sold after sending the Announcement campaign",
      subtitle: "STEP 3",
      contentImg:
        "/assets/images/membership/promotions/modal/campaign_help_3.svg",
    },
  ],
};

export const getDummyExpiryDate = ({ period, duration }) => {
  const now = new Date();

  if (period === "months") {
    now.setMonth(now.getMonth() + duration);
  } else if (period === "days") {
    now.setDate(now.getDate() + duration);
  } else {
    throw new Error('Invalid duration. Use "months" or "days".');
  }

  now.setHours(23, 59, 59, 999);
  return now.toISOString();
};

export const industryWisePrice = {
  food_beverage: 5000,
  beauty_wellness: 10000,
  retail: 5000,
  services: 5000,
  others: 5000,
};

export const loyaltyMembShortlinkTabs = [
  {
    key: "loyalty",
    text: "Offers",
    icon: <Hearts width={24} height={24} color="#ffffff" />,
  },
  {
    key: "membership",
    text: "Memberships",
    icon: <CreditCard02 width={24} height={24} color="#ffffff" />,
  },
];
